export function uniqueByKeys<T>(array: T[], keys: (keyof T)[]): T[] {
  const seen = new Set<string>();
  const result: T[] = [];

  for (const item of array) {
    const key = keys.map((k) => String(item[k])).join('|'); // 建立複合鍵
    if (!seen.has(key)) {
      seen.add(key);
      result.push(item);
    }
  }

  return result;
}

export function unique(data: string[]): string[] {
  return Array.from(new Set(data));
}
